module.exports = __webpack_public_path__ + "img/pic-03.04bb15b4.png";